document.addEventListener('DOMContentLoaded', function () {
  var modelView = localStorage.getItem('modelView');
  if (modelView === "true") {
    toggleModelView(true);
  }

  var toggleModelViewButtons = document.querySelectorAll('.toggle-model-view');

  toggleModelViewButtons.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
console.log("test");
      if (btn.dataset.productView === 'model') {
        localStorage.setItem('modelView', true);
        toggleModelView(true);
      } else {
        localStorage.setItem('modelView', false);
        toggleModelView(false);
      }
    })
  })
})

document.addEventListener('load_more_products', function () {
  var modelView = localStorage.getItem('modelView');
  if (modelView === "true") {
    toggleModelView(true);
  } else {
    toggleModelView(false);
  }
})

function toggleModelView(modelView = false) {
  var featuredPhotos = document.querySelectorAll('.featured-media');

  featuredPhotos.forEach((photo) => {
    if (modelView) {
      if (photo.dataset.modelView) {
        photo.src = photo.dataset.modelView;
        photo.srcset = photo.dataset.modelView;
      }
    } else {
      photo.src = photo.dataset.srcDefault;
      photo.srcset = photo.dataset.srcsetDefault;
    }
  });
}
